<i18n lang="yaml">
zh:
  freeEnergy: "重磅福利 10月1-10月7日码哩写作全站免费！"
  goToView: "前往查看"
  registerLogin: "注册/登录"
  account: "账号"
  recharge: "充值"
  setting: "设置"
  orderList: "购买记录"
  energyList: "能量明细"
  submission: "我的投稿"
  logout: "退出登录"
  rechargeStation: "能量补给站"
  energy: "能量"
  payAmount: "支付金额："
  payAgreement: "支付即视为您已同意"
  agreement: "《能量充值协议》"
  paySuccess: "充值成功"
  product: "商品："
  amount: "金额："
  phone: "手机号："
  userId: "用户ID："
  sorryNoEnergy: "抱歉，您的能量不足"
  pleaseRecharge: "如需继续使用，请充值能量"
  freeEnergyBtn: "免费能量"
  goRecharge: "去充值"
  aiAutoSetting: "创作故事时，AI 是否自动生成故事要素、大纲、正文等"
  save: "保存"
  inviteNewUser: "邀请新用户，免费领能量"
  inviteDesc: "每邀请1位新用户注册你可得5万能量，新用户可得10万能量"
  yourInviteLink: "你的专属邀请链接"
  tips: "提示："
  tips1: "1. 每日免费赠送能量仅当日有效"
  tips2: "2. 邀请好友获得的能量永久有效"
  tips3: "3. 好友必须使用邀请链接登录码哩写作才能获得能量"
  tips4: "4. 邀请多个好友可重复获得奖励"
  tips5: "5. 严禁使用作弊手段恶意注册、刷能量，若有发现则封号处理"
  tips6: "6. 本活动最终解释权归码哩写作所有"
  newGift: "新人大礼包"
  newUserGifted: "新用户注册，赠送10W能量已到账"
  usageGuide: "码哩写作使用说明"
  quickGuide: "快速了解码哩写作，点击查看 >"
  aiWritingClub: "AI写作研究会"
  joinGroup: "和主编大大技术大大一起探讨AI写作技巧，入群领《独家AI使用小窍门》"
  getNow: "立即领取"
  giveUp: "放弃领取"
  bindXiboPhone: "绑定喜播注册手机号，即可获得20万能量奖励～"
  getCode: "获取验证码"
  resendIn: "秒后重发"
  imageCode: "图形验证码"
  smsCode: "短信验证码"
  inputPhone: "请输入手机号"
  codeRequired: "请输入验证码"
  codeLength: "验证码长度必须为6位"
  phoneFormatError: "手机号格式有误！"
  energyForever: "直接购买的能量永久有效"
  payBy: "支付宝/微信扫码支付"
  firstInvite: "如果你是首次邀请，你可获得10万能量"
  total15w: "累计获得15万能量"
  extra10w: "额外获得10万能量"
  total30w: "累计获得30万能量"
  extra20w: "额外获得20万能量"
  invite: "邀请"
  one: "1位"
  three: "3位"
  six: "6位"
  youGet: "你可得5万能量，新用户可得10万能量"
  get20w: "20万能量领取成功！"
  canWrite2: "完成你的第一部AI小说"
  ok: "Okay!已了解"
  btn: "充值"
  copyInvite: "一键复制邀请链接"
  copySuccess: "复制成功"
  phoneRequired: "请输入手机号！"
  rechargeBar: "能量补给站"
  rechargeUser: "账号："
  rechargeEnergy: "能量："
  rechargeTitle: "能量补给站"

en:
  freeEnergy: "Free Energy Gift!"
  goToView: "Go to View"
  registerLogin: "Register/Login"
  account: "Account"
  recharge: "Recharge"
  setting: "Settings"
  orderList: "Purchase Records"
  energyList: "Energy Details"
  submission: "My Submissions"
  logout: "Logout"
  rechargeStation: "Energy Supply Station"
  energy: "Energy"
  payAmount: "Payment Amount:"
  payAgreement: "By paying, you agree to"
  agreement: "Energy Recharge Agreement"
  paySuccess: "Recharge Successful"
  product: "Product:"
  amount: "Amount:"
  phone: "Phone:"
  userId: "User ID:"
  sorryNoEnergy: "No Energy!"
  pleaseRecharge: "you can go back tomorrow, or contact the email:"
  freeEnergyBtn: "Free Energy"
  goRecharge: "Go to Recharge"
  aiAutoSetting: "Should AI automatically generate story elements, outlines, and content when creating stories?"
  save: "Save"
  inviteNewUser: "Invite new users, get free energy"
  inviteDesc: "For each new user you invite, you get 50,000 energy, and the new user gets 100,000 energy"
  yourInviteLink: "Your exclusive invite link"
  tips: "Tips:"
  tips1: "Please remind your friends to log in with your exclusive link"
  tips2: "After your friend logs in, the energy will be credited within 5 minutes"
  tips3: "You can repeatedly get rewards for inviting multiple new users"
  tips4: "Cheating or malicious registration is strictly prohibited. Violators will be banned"
  tips5: "The final interpretation right belongs to Mali Writer"
  tips6: "The final interpretation right belongs to Mali Writer"
  newGift: "New User Gift Pack"
  newUserGifted: "New users get 100,000 energy upon registration"
  usageGuide: "Mali Writer Usage Guide"
  quickGuide: "Quickly learn about Mali Writer, click to view >"
  aiWritingClub: "AI Writing Club"
  joinGroup: "Discuss AI writing skills with editors and tech experts, join the group for exclusive tips"
  getNow: "Get Now"
  giveUp: "Give Up"
  bindXiboPhone: "Bind your Xibo registered phone to get 200,000 energy reward~"
  getCode: "Get Code"
  resendIn: "Resend in seconds"
  imageCode: "Image Verification Code"
  smsCode: "SMS Verification Code"
  inputPhone: "Please enter your phone number"
  codeRequired: "Please enter the verification code"
  codeLength: "The code must be 6 digits"
  phoneFormatError: "Invalid phone number format!"
  energyForever: "Directly purchased energy is permanently valid"
  payBy: "Pay with Alipay/WeChat QR code"
  firstInvite: "If this is your first invite, you get 100,000 energy"
  total15w: "Total 150,000 energy"
  extra10w: "Extra 100,000 energy"
  total30w: "Total 300,000 energy"
  extra20w: "Extra 200,000 energy"
  invite: "Invite"
  one: "1 person"
  three: "3 people"
  six: "6 people"
  youGet: "You get 50,000 energy, new user gets 100,000 energy"
  get20w: "200,000 energy received!"
  canWrite2: "Can generate about 2 short novels~"
  ok: "Okay! Got it"
  btn: "Recharge"
  copyInvite: "Copy Invite Link"
  copySuccess: "Copied Successfully"
  phoneRequired: "Please enter your phone number!"
  rechargeBar: "Energy Supply Station"
  rechargeUser: "Account:"
  rechargeEnergy: "Energy:"
  rechargeTitle: "Energy Supply Station"
</i18n>

<template>
  <div class="parent">
    <!-- <div style="position: fixed;top: 30px;right: 30px;">
      <el-button type="primary" @click="changeLanguage">中文/English</el-button>
    </div> -->

    <div v-if="showCuxiaoFlag" class="d-flex flex-between" style="font-weight: 400;background: linear-gradient( 90deg, #0052D9 0%, #D9DCFF 100%);
        border-radius:none;padding: .5rem 1rem;
        font-size: 14px;align-items: center;
        color: #FFFFFF;">
      <div class="d-flex" style="align-items: center;">
        <!-- 打折促销 -->
        <!-- <img style="height: 20px;margin-right: .3rem;" src="@/assets/dazhecuxiao.png" alt="" />年终大促！充值能量超低福利限时 7 折，将于11月12号00:00结束～ <span class="pointer " style="text-decoration: underline;" @click="handleCommand('recharge')">前往查看</span> -->
        <!-- 免费能量 -->
        <img style="height: 20px;margin-right: .3rem;" src="@/assets/icon-liwu.png" alt="" />{{ $i18n.t('freeEnergy') }} <span class="pointer " style="text-decoration: underline;" @click="shuangdanPage">{{ $i18n.t('goToView') }}</span>
      </div>
      <i @click="guanbiCuxiao" style="color: #000000;" class="el-icon-close pointer"></i>
    </div>

    <el-row class="child" type="flex" justify="space-between" style="background: #242424;padding: 12px 1rem;align-items: center;max-width: 1400px;margin: 0 auto;">
        <img :style="{'height': innerWidth<768?'12px':'26px'}" @click="goHome" class="pointer" src="@/assets/logo1.png" />
        <div class="d-flex" style="align-items: center;">
          <div v-if="token==''" style="cursor: pointer;display: inline-block">
            <el-button style="border-radius: 6px !important;padding: 0.5rem 2rem;" size="small" type="primary"  @click="setShowLoginDialogFlag(true)">{{ $i18n.t('registerLogin') }}</el-button>
          </div>
          <div class="" v-if="token!='' && $i18n.locale === 'zh' && !user.downloadFlag && !$isMobile() && $detectEnvironment()=='browser'" @click="onDownload" style="cursor: pointer;display: inline-flex;position: relative;">
            <el-button icon="el-icon-download" class="mly-border-radius-20" style="padding: 0.55rem 1rem;margin-right: .5rem;" size="small" type="primary">下载桌面版领10万能量</el-button>
          </div>
          <div class="" v-if="token!='' && $i18n.locale === 'zh'" @click="onInvite" style="cursor: pointer;display: inline-flex;position: relative;">
            <img src="@/assets/btn-give.png" style="margin-right: 10px;height: 35px;">
            <div class="ly-reddot-give shake badge" v-show="!user.giveFlag || !user.downloadFlag">
              未领取
            </div>
          </div>
          <el-dropdown v-if="token!=''" @command="handleCommand" :trigger="($isTouchDevice())?'click':'hover'" ref='dropShow' @visible-change='trueOrfalse'>
            <div style="align-items: center;cursor: pointer; display: flex;background: linear-gradient( 90deg, rgba(0, 82, 217, .4) 0%, rgba(58, 231, 255, .4) 49%, rgba(74, 71, 255, .4) 100%);border-radius: 60px;align-items: center;">
              <img src="@/assets/user-energy.png" style="height: 30px;margin-left: 2px;">
              <div v-if="!user.freeFlag||(user.freeFlag&&!isNextDayEqualToToday())" style="padding-right: .6rem;font-weight: bold;color: rgba(255,255,255,1);">{{ user.score }}</div>
              <div v-else style="padding-right: .6rem;">
                <div style="display: flex;justify-content: center;">
                  <div class="" style="width: 20px;" ref="freeContainer1"></div>
                </div>
                <div style="font-weight: bold;color: rgba(255,255,255,1);font-size: 10px;padding-bottom: 2px;">
                  {{initityTime}}
                </div>
              </div>
            </div>
            <el-dropdown-menu class="custom-dropdown" slot="dropdown" style="background: #404040;
                box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.1), 0px 8px 10px 1px rgba(0,0,0,0.06), 0px 3px 14px 2px rgba(0,0,0,0.05);
                border-radius: 6px;border: none;">
              <el-dropdown-item command="xx">
                <div style="">
                  <div style="display: flex;align-items: center;"><img src="@/assets/touxiang.png" style="width: 1.5rem;"><span style="">{{ $i18n.t('account') }}：{{ user.username }}</span></div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="$i18n.locale === 'zh'" command="recharge">
                <div style=" display: flex;align-items: center;">
                  <img src="@/assets/recharge-icon.png" style="width: .9rem;"><span style="">{{ $i18n.t('recharge') }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="setting">
                <div style=" display: flex;align-items: center;">
                  <img src="@/assets/icon-menu-setting.png" style="width: .9rem;"><span style="">{{ $i18n.t('setting') }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="$i18n.locale === 'zh'" command="orderlist">
                <div style=" display: flex;align-items: center;">
                  <img src="@/assets/orderlist-icon.png" style="width: .9rem;"><span style="">{{ $i18n.t('orderList') }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="$i18n.locale === 'zh'" command="energylist">
                <div style=" display: flex;align-items: center;">
                  <img src="@/assets/energylist-icon.png" style="width: .9rem;"><span style="">{{ $i18n.t('energyList') }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="$i18n.locale === 'zh'" command="submission">
                <div style=" display: flex;align-items: center;">
                  <img src="@/assets/icon-submission.png" style="width: .9rem;"><span style="">{{ $i18n.t('submission') }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <div style=" display: flex;align-items: center;">
                  <img src="@/assets/logout-icon.png" style="width: .9rem;"><span style="">{{ $i18n.t('logout') }}</span>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-if="token!='' && $i18n.locale === 'en'" style="margin-left: 10px;cursor: pointer;" @click="goContactEmail">
            <img src="@/assets/icon-email-contact.png" style="width: 30px;" />
          </div>

          <!-- 通知 -->
          <div class="pointer" v-if="$i18n.locale === 'zh'">
            <div ref="lottieContainer" @click="tongzhi" style="width: 60px; height: 46px;position: relative;">
              <div class="ly-reddot" v-if="unreadCount > 0">
                {{ unreadCount }}
              </div>
            </div>
            <!-- <img :style="{'height': innerWidth<768?'12px':'26px'}" @click="tongzhi" class="pointer" src="@/assets/tongzhi-icon.png" /> -->
          </div>
        </div>

       <!-- 能量充值 弹窗 -->
           <el-dialog :append-to-body="true" class="custom-dialog recharge-dialog" ref="rechargeDialog"
             :visible.sync="dialogShowRechargeFlag"
             @close="close">
               <div class="recharge">
                 <div slot="title" class="recharge-user-bg">
                   <div class="recharge-user-img d-flex flex-y-center">
                     <div class="recharge-user-avatar"><img src="@/assets/touxiang-2.png" style="width: 3.375rem;"></div>
                     <div class="recharge-user-info">
                       <div class="recharge-user-info-item">{{ $i18n.t('rechargeUser') }}：{{ user.username }}</div>
                       <div class="recharge-user-info-item">{{ $i18n.t('rechargeEnergy') }}：{{ user.score }}</div>
                     </div>
                   </div>
                 </div>
                 <div class="recharge-title">
                   <div class="recharge-title-box d-flex flex-y-center" style="justify-content: center; padding: .5rem;">
                     <span><img style="width: 1rem" src="@/assets/recharge-bar.png" alt="" /></span>
                     <span class="recharge-title-box-text" style="">{{ $i18n.t('rechargeStation') }}</span>
                   </div>
                 </div>
                 <div style="position: relative;">
                   <div class="recharge-energy d-flex container scroll-transition" style="border-right: 1px solid rgba(0, 0, 0, .1);position: relative;" ref="scrollContainer">
                     <div class="recharge-energy-item" style="position: relative;" :class="{'recharge-energy-item-active': energyActivedIndex == index}" @click="energyActive(index)"
                       v-for="(item,index) in energyCards" :key="index">
                       <span v-if="index == 0" style="background: transparent;padding: 0.25rem .5rem;color: transparent;
                         border-radius: 20px 0px 20px 0px;position: absolute;left: -4px;top: -4px;">{{$i18n.locale === 'zh' ? item.brief : item.desc}}</span>
                       <span v-else style="background: #0052D9;padding: 0.25rem .5rem;
                         border-radius: 20px 0px 20px 0px;position: absolute;left: -4px;top: -4px;">{{$i18n.locale === 'zh' ? item.brief : item.desc}}</span>
                       <div class="recharge-energy-item-title recharge-energy-item-text d-flex flex-y-center" style="margin: 0 1rem;margin-top: 1.8rem;">
                         <div class="" style="width: 1.8rem;height: 1.8rem;">
                           <img src="@/assets/energy-icon.png" style="width: 100%;padding-bottom: .9rem;"/>
                         </div>
                         <div class="text-gradient" style="display: inline-block !important;width: auto;">{{item.title}}</div>
                       </div>
                       <div class="recharge-energy-item-text" style="margin-top: 1rem;">
                         <span style="font-size: 16px;padding: 0;">￥</span>
                         <span>{{item.price}}</span>
                       </div>
                       <div v-if="index > 0" class="recharge-energy-item-text">
                         <span style="font-weight: 400;font-size: 14px;color: rgba(0,0,0,0.4);">￥</span>
                         <span style="font-weight: 400;font-size: 20px;color: rgba(0,0,0,0.4);text-decoration: line-through;">{{item.screenPrice}}</span>
                       </div>
                       <div style="height: 1.5rem;"></div>
                     </div>
                   </div>
                   <!-- 左右箭头 -->
                   <div v-if="!isMobileFlag" class="d-flex" :style="{'position': 'absolute','left': '2.2rem', 'top': '42%'}">
                       <span style="" class="slider-arraw el-icon-arrow-left" @click="scrollLeft"></span>
                     </div>
                     <div v-if="!isMobileFlag" class="d-flex" style="position: absolute;right: 2.2rem; top: 42%;">
                       <span style="" class="slider-arraw el-icon-arrow-right" @click="scrollRight"></span>
                     </div>
                 </div>
                 <div class="" style="font-weight: 400;font-size: 12px;color: #3B81F4;padding: .5rem 0;margin: 0 2rem;">
                   *{{ $i18n.t('energyForever') }}
                 </div>
                 <div class="recharge-pay d-flex flex-between flex-y-center">
                   <div class="recharge-pay-left">
                     <div class="">
                       <span style="font-weight: 400;font-size: 14px;color: #151515;">{{ $i18n.t('payAmount') }}</span>
                       <span style="font-weight: 400;font-size: 16px;color: #0052D9;">￥</span>
                       <span style="font-weight: 600;font-size: 2rem;color: #0052D9;">{{energyCard.price}}</span>
                     </div>
                     <div class="" style="margin-top: 1rem;">
                        <span style="font-weight: 400;font-size: 14px;color: #151515;">{{ $i18n.t('payAgreement') }}</span>
                        <a style="font-weight: 400;font-size: 14px;color: #0052D9;" target="_blank" href="recharge.html">{{ $i18n.t('agreement') }}</a>
                      </div>
                   </div>
                   <div class="recharge-pay-right" style="text-align: right;">
                     <el-button type="primary" v-if="isMobileFlag" @click="goRecharge">{{ $i18n.t('btn') }}</el-button>
                     <img style="width: 7rem;border: 2px solid #ffffff;" v-else :src="imgUrl"/>
                     <div class="d-flex flex-y-center" v-if="!isMobileFlag" style="font-size: 12px;color: #151515;padding: .2rem 0;">
                       <img src="@/assets/pay-icon.png" style="width: 31px; height: 13px;padding-right: .2rem;"/>
                       <span>{{ $i18n.t('payBy') }}</span>
                     </div>
                   </div>
                 </div>
                 <div style="height: 1rem;"></div>
               </div>
           </el-dialog>

        <!-- 新人大礼包 -->
        <el-dialog :append-to-body="true" class="newer-gift-dialog-v2"
              title=""
              top="10vh"
              :visible.sync="dialogShowNewerGiftFlag && $i18n.locale === 'zh'"
              @close="close"
              style="margin: 0 auto;border: none;">

              <div class="body-zuiwaiceng">
                <div class="mly-p" style="">

                  <div style="color: #242424;" class="mly-mt mly-fs-small">
                    码哩写作 | 开启创作新篇章，用文字创造无限可能！
                  </div>

                  <div style="" class="mly-pc-mt-25">
                    <h2 class="mly-fs-middle" style="color: #366EF4;margin-bottom: 0.5rem;margin-top: 1.25rem;">{{ $i18n.t('newGift') }}</h2>
                  </div>
                  <div style="color: #000000;" class="mly-fs-small">
                    {{ $i18n.t('newUserGifted') }}
                  </div>

                  <div class="mly-pc-mt-2">
                    <!-- <h2 class="mly-fs-middle" style="color: #000000;margin-bottom: 0.5rem;margin-top: 1.25rem;">{{ $i18n.t('usageGuide') }}</h2> -->
                    <h2 class="mly-fs-middle" style="color: #366EF4;margin-bottom: 0.5rem;margin-top: 1.25rem;">10月限时活动：2万能量日日领</h2>
                  </div>
                  <div style="color: #000000;" class="mly-fs-small mly-pc-mb-1">
                    <!-- <a style="color: #366EF4;" target="_blank" href="https://qcnx120ai68z.feishu.cn/wiki/D1Qkw0Kqoic66MkvL0NcAw8gnqg">{{ $i18n.t('quickGuide') }}</a> -->
                    免费能量补给站
                  </div>

                </div>
                <!-- 下半部分 -->
                <div class="mobile-bg-circle">
                  <div class="mly-p" style="display: flex;justify-content: space-between;">

                    <div class="">
                      <div style="">
                        <h2 class="mly-fs-middle" style="color: #366EF4;margin-bottom: 0.5rem;margin-top: 1.25rem;">{{ $i18n.t('aiWritingClub') }}</h2>
                      </div>
                      <div class="mly-fs-small" style="color: #000000;line-height: 20px;padding-right: 8px;">
                        {{ $i18n.t('joinGroup') }}
                      </div>
                    </div>

                    <div style="display: flex; align-items: flex-end;">
                      <img src="https://maliwriter.com/static/qrcoe-3.png" style="height: 80px; border-radius: 6px;"/>
                    </div>
                  </div>

                  <div v-if="!$isLastDigitOdd(user.id)" @click.stop="lingqu" style="text-align: center;cursor: pointer;">
                    <div class="invite-button" @click.stop="lingqu" style="position: relative;margin-top: 2rem; background: linear-gradient( 270deg, #0052D9 0%, #00FFC2 100%);
                    border-radius: 20px;display: inline-flex;padding: .5rem 4rem;font-weight: 600;">
                             领取今日能量
                     </div>
                  </div>
                  <div v-if="$isLastDigitOdd(user.id)" @click.stop="lijichuangzuo" style="text-align: center;cursor: pointer;">
                    <div class="invite-button" @click.stop="lijichuangzuo" style="position: relative;margin-top: 2rem; background: linear-gradient( 270deg, #0052D9 0%, #00FFC2 100%);
                    border-radius: 20px;display: inline-flex;padding: .5rem 4rem;font-weight: 600;">
                             立即创作
                     </div>
                  </div>
                </div>
              </div>

            </el-dialog>

        <el-dialog :append-to-body="true" class="newer-gift-dialog-v2-en"
          title=""
          :visible.sync="dialogShowNewerGiftFlag && $i18n.locale === 'en'"
          style="margin: 0 auto;">
          <img src="@/assets/newer-gift-en.png" style="width: 100%;" @click="close"/>
        </el-dialog>

        <!-- 喜播 新人大礼包 -->
        <el-dialog :append-to-body="true" class="newer-gift-dialog-v2 newer-gift-dialog-xibo-v2"
              title=""
              top="10vh"
              :visible.sync="dialogShowNewerGiftXiboFlag && $i18n.locale === 'zh'"
              @close="closeXibo"
              style="margin: 0 auto;border: none;">

              <div v-if="user.xiboPhone" class="body-zuiwaiceng">
                <div class="mly-p" style="">

                  <div style="color: #00F2B8;" class="mly-mt mly-fs-small">

                  </div>
                  <div style="color: rgba(36, 36, 36, .8);padding-top: .5rem;" class="mly-mt mly-fs-small">
                    码哩写作 | 开启创作新篇章，用文字创造无限可能！
                  </div>

                  <div style="" class="mly-pc-mt-25">
                    <h2 class="mly-fs-middle" style="color: #366EF4;margin-bottom: 0.5rem;margin-top: 1.25rem;">{{ $i18n.t('get20w') }}</h2>
                  </div>
                  <div style="color: rgba(36, 36, 36, .8);" class="mly-fs-small">
                    {{ $i18n.t('canWrite2') }}
                  </div>

                  <div class="mly-pc-mt-2">
                    <h2 class="mly-fs-middle" style="color: #366EF4;margin-bottom: 0.5rem;margin-top: 1.25rem;">10月限时活动：2万能量日日领</h2>
                  </div>
                  <div style="color: rgba(36, 36, 36, .8);" class="mly-fs-small mly-pc-mb-1">
                    免费能量补给站
                    <!-- <a style="color: #366EF4;" target="_blank" href="https://qcnx120ai68z.feishu.cn/wiki/CuTuwXTpaifTflkpWiQcCZIlnSe">{{ $i18n.t('quickGuide') }}</a> -->
                  </div>

                </div>
                <!-- 下半部分 -->
                <div class="mobile-bg-circle">
                  <div class="mly-p" style="display: flex;justify-content: space-between;">

                    <div class="">
                      <div style="">
                        <h2 class="mly-fs-middle" style="color: #366EF4;margin-bottom: 0.5rem;margin-top: 1.25rem;">AI写作研究会</h2>
                      </div>
                      <div class="mly-fs-small" style="color: rgba(36, 36, 36, .8);line-height: 20px;padding-right: 8px;">
                        扫码添加你的专属管家☎️，独家指令助你快速过稿💰！
                      </div>
                    </div>

                    <div style="display: flex; align-items: flex-end;">
                      <img src="https://maliwriter.com/static/qiye-qrcode.png" style="height: 120px; border-radius: 6px;"/>
                    </div>
                  </div>

                  <div @click.stop="close" style="text-align: center;cursor: pointer;">
                    <div class="invite-button" @click.stop="close" style="position: relative;margin-top: 1rem; background: linear-gradient( 270deg, #0052D9 0%, #00FFC2 100%);
                        border-radius: 20px;display: inline-flex;padding: .5rem 4rem;font-weight: 600;">
                        领取今日能量
                     </div>
                 </div>
                </div>
              </div>
              <!-- 没绑定手机号 -->
              <div v-else class="body-zuiwaiceng">
                <div class="mly-p" style="">
                  <div style="color: rgba(36, 36, 36, .8);margin-bottom: 1rem;padding-top: .5rem;" class="mly-mt mly-fs-small">
                    {{ $i18n.t('bindXiboPhone') }}
                  </div>
                  <el-form :model="form" ref="formRef" :rules="rules" class="login-form" label-position="left" :hide-required-asterisk='true'>
                      <div class="d-flex">
                        <el-form-item prop="xiboPhone" class="mb" style="flex: 1;">
                          <el-input v-model="form.xiboPhone" prefix-icon="el-icon-phone" placeholder="请输入手机号" autocomplete="on" class="custom-input-text rounded-input" clearable />
                        </el-form-item>
                      </div>

                      <el-form-item prop="imageVerifycode" class="mb" v-if="form.xiboPhone && form.xiboPhone.length==11 && user.username!=form.xiboPhone">
                        <el-input v-model="form.imageVerifycode" placeholder="图形验证码" class="custom-input-text rounded-input" clearable>
                          <template slot="append">
                            <div @click="getImageVerifycode"
                             style="cursor: poiner; display: flex;justify-content: center;align-items: center;border-radius: 10px;background-color: #ffffff;">
                              <img style="width: 120px;height: 36px;" :src="imageVerifycodeData" class="" />
                            </div>
                          </template>
                        </el-input>
                      </el-form-item>

                      <el-form-item prop="verifyCode" class="mb" v-if="form.xiboPhone && form.xiboPhone.length==11 && user.username!=form.xiboPhone">
                        <el-input v-model="form.verifyCode" ref="verificationCodeInput" placeholder="短信验证码" class="custom-input-text rounded-input" clearable>
                          <template slot="append">
                              <el-button  @click="startCountdown" :loading="isGetCodeLoading" :disabled="getCaptchaDisabled" class="yanzhengma1">
                                {{ getCaptchaDisabled ? `${timeLeft}秒后重发` : $i18n.t('resendIn') }}
                              </el-button>
                            </template>
                          </el-input>
                      </el-form-item>
                  </el-form>
                </div>
                <!-- 下半部分 -->
                <div class="mobile-bg-circle">
                    <div class="d-flex flex-center-x" style="padding: 0 30px;">
                      <el-button style="border-radius: 20px !important;width: 100%;margin-top: 1rem;" class="mt" type="primary" @click="handlebindPhone(true)">{{ $i18n.t('getNow') }}</el-button>
                      <div class="pointer" @click="handlebindPhone(false)" style="color: #366EF4;margin-top: 1rem;">{{ $i18n.t('giveUp') }}</div>
                    </div>
                </div>
              </div>
            </el-dialog>

        <!-- 充值成功 弹窗 -->
        <el-dialog :append-to-body="true" class="custom-dialog writer-cashier-dialog"
          title=""
          :visible.sync="dialogShowPaySuccessFlag && $i18n.locale === 'zh'"
          @close="close('pay-success')"
          style="margin: 0 auto;">
            <div class="writer-cashier">
              <div class="writer-cashier-flag d-flex flex-y-center" style="width: 100%;">
                <img src="@/assets/pay-success.png" style="width: 3.75rem;"/>
                <div class="" style="font-size: 2rem; padding: .5rem;font-weight: 600; color: #151515;">
                  {{ $i18n.t('paySuccess') }}
                </div>
              </div>

              <div class="writer-cashier-info">

                <div class="writer-cashier-info-item">
                  <span>{{ $i18n.t('product') }}</span>
                  <span>{{energyPaySuccess.sku?energyPaySuccess.sku.title:''}}</span>
                </div>

                <div class="writer-cashier-info-item">
                  <span>{{ $i18n.t('amount') }}</span>
                  <span>￥{{energyPaySuccess.payMoney}}</span>
                </div>

                <div class="writer-cashier-info-item">
                  <span>{{ $i18n.t('phone') }}</span>
                  <span>{{energyPaySuccess.phone}}</span>
                </div>

                <div class="writer-cashier-info-item">
                  <span>{{ $i18n.t('userId') }}</span>
                  <span>{{energyPaySuccess.accountId}}</span>
                </div>
              </div>

            </div>
        </el-dialog>

        <!-- 能量耗尽 弹窗 -->
        <el-dialog v-if="$i18n.locale === 'zh'" :append-to-body="true" class="custom-dialog"
          title=""
          :visible.sync="dialogShowCostomContactFlag"
          @close="close"
          style="text-align: center;width: 40rem; margin: 0 auto;">
            <div class="d-flex flex-y-center">
              <img style="width: 2rem; height: 2rem;" src="@/assets/no-energy.png"/>
              <h2 style="color: #151515;">{{ $i18n.t('sorryNoEnergy') }}</h2>
            </div>
            <div style="color: #151515;padding-left: 2rem;text-align: left;">{{ $i18n.t('pleaseRecharge') }}</div>
            <div class="" style="margin-top: 3rem; margin-bottom: 1rem;">
              <el-button type="default" class='custom-button' style="border-radius: 10px;"  :size="$root.buttonSize" round @click="onInvite">{{ $i18n.t('freeEnergyBtn') }}</el-button>
              <el-button type="primary" class="custom-button" style="border-radius: 10px;" :size="$root.buttonSize" @click="recharge4noEnergy">{{ $i18n.t('goRecharge') }}</el-button>
            </div>
        </el-dialog>

        <el-dialog v-if="$i18n.locale === 'en'" :append-to-body="true" class="custom-dialog"
          title=""
          :visible="dialogShowCostomContactFlag"
          @close="close"
          style="text-align: center;width: 50rem; margin: 0 auto;">
            <div class="d-flex flex-y-center">
              <h2 style="color: #151515;text-align: center;font-size: 2rem;width: 100%;">{{ $i18n.t('sorryNoEnergy') }}</h2>
            </div>
            <img style="width: 3rem; height: 3rem;" src="@/assets/no-energy.png"/>
            <div style="color: #151515;text-align: center;margin-top: 1rem;color: rgba(0, 0, 0, 0.80);">you can go back tomorrow, or contact the email:</div>
            <p style="color: #151515;text-align: center;margin-top: 1rem;font-weight: 600;">yilan2755@gmail.com</p>
            <div class="" style="margin-top: 1rem; margin-bottom: 1rem;">
              <el-button type="primary" class="custom-button" style="border-radius: 10px!important;" :size="$root.buttonSize" @click="setDialogShowCostomContactFlag(false)">okay!</el-button>
            </div>
        </el-dialog>

        <!-- 设置 弹窗 -->
        <el-dialog :append-to-body="true" class="custom-dialog"
          title=""
          :visible.sync="showSettingFlag"
          @close="close"
          style="text-align: center;margin: 0 auto;">
            <div class="d-flex flex-y-center">
              <span style="color: #000000;">{{ $i18n.t('aiAutoSetting') }}</span>
              <span>
                <el-switch
                  v-model="user.desktopFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </span>
            </div>
            <div class="" style="margin-top: 3rem; margin-bottom: 1rem;">
              <el-button type="primary" class="custom-button" style="border-radius: 10px;" :size="$root.buttonSize" @click="handleUpdateSetting()">{{ $i18n.t('save') }}</el-button>
            </div>
        </el-dialog>

        <!-- 邀请赚能量 弹窗 -->
        <div id="inviteText" v-show="false">
          {{getInviteText()}}
        </div>

        <!-- 2025/09/01 适配 -->
        <el-dialog :append-to-body="true" class="invite-newer-gift-dialog-v2"
              title=""
              top="10vh"
              :visible.sync="showInviteFlag"
              @close="close"
              style="margin: 0 auto;border: none;">

              <div class="body-zuiwaiceng">
                <div class="mly-p" style="">
                  <!-- 标题区域 -->
                  <div class="mly-mt " style="display: flex;align-items: center;margin-bottom: .5rem;">
                      <div style="display: flex;align-items: center;background: linear-gradient( 270deg, #00FFC2 0%, #78F7FF 100%);
                          border-radius: 6px;padding: .25rem .5rem;">
                          <img src="@/assets/give-energy-clock.png" style="width: 20px;" />
                          <div class=" mly-fs-middle" style="font-weight: 600;color: #027157;">10月限时活动</div>
                      </div>
                      <div class="mly-fs-middle-large" style="font-weight: 600;margin-left: .5rem;
                          color: #08465B;">免费能量补给站</div>
                  </div>

                  <!-- 倒计时区域 -->
                  <div class="" style="background: rgba(0,255,194,0.08);
                      border-radius: 12px;">
                      <!-- 倒计时 -->
                      <div v-if="!giveSuccessFlag" style="padding-top: 1rem;">
                        <div class="d-flex" style="justify-content: center; align-items: center;">
                         <div class="" style="font-weight: 600; font-size: 24px; color: #08465B;">
                              <span class="time-item">{{hour}}</span>
                              <span class="" style="padding: 0 .25rem;rgba(54,110,244,0.67)">:</span>
                              <span class="time-item">{{minute}}</span>
                              <span class="" style="padding: 0 .25rem;rgba(54,110,244,0.67)">:</span>
                              <span class="time-item">{{second}}</span>
                            </div>
                        </div>
                      </div>

                      <!-- 数字 -->
                      <div v-if="!giveSuccessFlag" >
                        <div class="d-flex"
                             style="padding: 15px;justify-content: center;align-items: center;">
                          <div v-if="user.giveFlag&&(isFreeNewer()||isNextDayEqualToToday())" style="display: flex;justify-content: center;">
                            <div class="" style="width: 50%;" ref="freeContainer"></div>
                          </div>
                          <img v-else style="width: 50%;" src="@/assets/give-2w.png"/>
                        </div>
                      </div>

                      <!-- 领取成功动画 -->
                      <div v-if="giveSuccessFlag" style="display: flex;justify-content: center;margin-top: -40px;">
                        <div v-if="giveSuccessFlag" class="" style="width: 40%;" ref="giveSuccessContainer">

                        </div>
                      </div>

                      <!-- 按钮 区域 -->
                      <div style="text-align: center;">
                        <div :class="{'give-done': user.giveFlag&&user.freeFlag}"
                             style="text-wrap: nowrap;display: inline-flex;
                                    background: linear-gradient(270deg, #0052D9 0%, #00FFC2 100%);
                                    border-radius: 20px;padding: .5rem 3rem;font-weight: 600;">
                             <div style="cursor: pointer;" v-if="!user.giveFlag" @click="giveGift">领取今日免费能量</div>
                             <!-- <span v-else>今日已领，明日再来</span> -->
                            <div style="cursor: pointer;" v-if="(!user.freeFlag)&&user.giveFlag&&isNextDayEqualToToday()" @click="freeGift">领取限时无限能量</div>
                            <div style="" v-if="user.giveFlag&&user.freeFlag||(user.giveFlag&&!user.freeFlag&&!isFreeNewer()&&!isNextDayEqualToToday())">{{'已领取,明日继续'}}</div>
                            <div style="" v-if="user.giveFlag&&!user.freeFlag&&isFreeNewer()">{{'明日来领无限能量'}}</div>
                         </div>
                      </div>

                      <!-- 说明 -->
                      <div style="display: flex;justify-content: center;padding: .5rem;
                                  font-weight: 400;
                                  font-size: 12px;
                                  color: rgba(0,82,217,0.5);">
                        {{user.giveFlag&&isFreeNewer()?"限时无限能量包，限制时间内无限使用能量～":"每日可领取2万免费能量，当天使用有效，过期自动扣除"}}
                      </div>
                  </div>

                </div>

                <!-- 下半部分 -->

                <!-- 未领取 -->
                <div class="mobile-bg-circle mly-p weilingqu">

                  <div style="margin-top: .5rem;
                                display: flex;justify-content: space-between;align-items: center;
                                padding: 1rem 1rem; background: rgba(0,82,217,0.06);
                                border-radius: 12px;">
                    <div class="mly-fs-middle">
                      <div style="font-weight: 600;
                                  color: #08465B;">
                        下载安装码哩写作桌面版：
                      </div>
                      <div class="mly-fs-small" style="font-weight: 400;margin-top: 10px;color: #08465B;">
                        打开桌面版可领取<div style="color: #0362FF;font-weight: 600;text-wrap: nowrap;padding:0;display: inline-block;">10万</div>能量奖励
                      </div>
                    </div>

                    <div @click.stop="$detectEnvironment()=='browser'?onDownload():downloadGift()"  style="text-align: center;">
                      <div class="invite-button" @click.stop="$detectEnvironment()=='browser'?onDownload():downloadGift()"
                        style="position: relative; background: linear-gradient( 270deg, #0052D9 0%, #00FFC2 100%);text-wrap: nowrap;cursor: pointer;
                                border-radius: 20px;display: inline-flex;padding: .5rem 2rem;font-weight: 600;">
                           {{$detectEnvironment()=='desktop'?(user.downloadFlag?'领取成功':'领取能量'):'下载领取'}}
                       </div>
                    </div>
                  </div>

                  <!-- mianfeiling -->
                  <div class="" style="margin-top: .5rem;margin-bottom: .5rem;
                                display: flex;justify-content: space-between;align-items: center;
                                padding: 1rem 1rem; background: rgba(0,82,217,0.06);
                                border-radius: 12px;">
                    <div class="mly-fs-middle">
                      <div style="font-weight: 600;
                                  color: #08465B;">
                        邀请得免费能量：
                      </div>
                      <div class="mly-fs-small" style="font-weight: 400;margin-top: 10px;color: #08465B;">
                        每邀请1位新用户注册，可得<div style="color: #0362FF;font-weight: 600;text-wrap: nowrap;padding:0;display: inline-block;">5万</div>能量奖励
                      </div>
                    </div>

                    <div @click.stop="copyInviteText" style="text-align: center;cursor: pointer;">
                      <div class="invite-button" @click.stop="copyInviteText"
                        style="position: relative; background: linear-gradient( 270deg, #0052D9 0%, #00FFC2 100%);text-wrap: nowrap;
                                border-radius: 20px;display: inline-flex;padding: .5rem 1rem;font-weight: 600;">
                           {{inviteBtnText}}
                       </div>
                    </div>
                  </div>

                  <!-- tooltip -->
                  <el-tooltip popper-class="" placement="top-start">

                    <template #default>
                      <div style="display: flex;align-items: center;font-size: 12px;width: 80px;">
                        <img src="../assets/icon-info.png" style="width: 16px;margin-right: 4px;" />
                        <div style="color: #185165;">规则提示</div>
                      </div>
                    </template>

                    <template #content>
                      <div style="font-weight: 400;
                                  font-size: 12px;color: rgba(255, 255, 255, .8);
                                  text-align: left;line-height: 1.25rem;padding: .5rem;">
                        提示：
                        <br>
                                  {{ $i18n.t('tips1') }}
                        <br>
                                  {{ $i18n.t('tips2') }}
                        <br>
                                  {{ $i18n.t('tips3') }}
                        <br>
                                  {{ $i18n.t('tips4') }}
                        <br>
                                  {{ $i18n.t('tips5') }}
                        <br>
                                  {{ $i18n.t('tips6') }}
                      </div>
                    </template>

                  </el-tooltip>
                </div>

                <!-- 领取成功 -->
                <div v-if="giveSuccessFlag" class="mobile-bg-circle mly-p lingquchenggong">
                  <div class="d-flex flex-between" style="margin-top: .5rem;gap: 24px;padding-bottom: 1rem;">
                    <div v-if="item.id" class="left d-flex-1">
                      <div class="mly-fs-middle-large" style="color: #08465B;font-weight: 600;margin-bottom: 1rem;">
                        继续创作
                      </div>
                      <div class="">
                          <el-card class="writer-story-card" style="position: relative;"
                              @click.native.stop="itemClick(item)">
                                <div class="word-count-tail" :class="{'word-count-tail-dp': item.articleGenType == 'GEN_BY_ZHIHU' || item.articleGenType == 'GEN_BY_OUTLINE','word-count-tail-cdp': item.articleGenType == 'GEN_BY_IDEA' || item.articleGenType == 'GEN_BY_CHANGPIAN'}">
                                  {{ getTailByGenType(item) }}
                                </div>
                                <div class="writer-story-card-title-header d-flex" style="justify-content: space-between;margin-top: 1rem;">
                                  <div class="ellipsis2 writer-story-card-title d-flex-1">
                                    <span style="padding: 0;" v-if="item.title">{{ item.title }}</span>
                                    <span v-else style="color: #999;">{{ $i18n.locale === 'zh' ? '该故事还没有名字' : 'This story has no name' }}</span>
                                  </div>
                                </div>
                                <div class="d-flex" style="margin-top: .5rem;">
                                  <div style="background: #F1F2FF;border-radius: 20px;font-size: 12px;color: #366EF4;padding: .25rem .5rem;">{{item.articleGenTypeLabel}}</div>
                                  <!-- <div style="margin-left:.5rem;background: #F1F2FF;border-radius: 20px;font-size: 12px;color: #366EF4;padding: .25rem .5rem;">{{item.articleTypeLabel}}</div>
                                  <div style="margin-left:.5rem;background: #F1F2FF;border-radius: 20px;font-size: 12px;padding: .25rem .5rem;" v-if="item.articleGenType!='GEN_BY_CHANGPIAN'" :style="{'color': item.articleState=='COMPLETED'?'#366EF4':'#A6A3A3'}">{{item.articleStateLabel}}</div> -->
                                </div>
                                <div class="" style="display: flex;align-items: center;justify-content: space-between;margin-top: .5rem;">
                                  <div class="writer-story-card-time">
                                    <span class="writer-story-card-time-label">{{ $i18n.locale === 'zh' ? '最近编辑' : 'Recently Edited' }}</span>
                                    <span>{{ $i18n.locale === 'zh' ? $time.formatTime(new Date(item.updateTime).getTime()) : $time.formatTimeEn(new Date(item.updateTime).getTime()) }}</span>
                                  </div>
                                  <div class="writer-story-card-menu">

                                  </div>
                                </div>
                          </el-card>
                      </div>
                    </div>
                    <div class="right d-flex-1">
                      <div class="mly-fs-middle-large" style="color: #08465B;font-weight: 600;">
                        创建新故事
                      </div>
                      <div class="">
                        <div class="story-item"  @click="handleGen('genbyzhihu')">
                          短篇小说
                        </div>
                        <div class="story-item" @click="handleGen('chaishu')">
                          拆书学习
                        </div>
                        <div class="story-item" @click="handleGen('genbyoutline')">
                          短篇定制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </el-dialog>


        <!-- menu v-if="isXsOrDown && isInPagePath"-->
        <div class="pointer" v-if="isXsOrDown && isInPagePath" @click="setShowMenuFlag(!showMenuFlag)"
         style="position: absolute;
           top: 10vh;
           left: 0;
           width: 30px;height: 50px;
           display: flex;align-items: center;justify-content: center;
           background: #E5E7FC;
           z-index: 999;
           border-radius: 0 10px 10px 0;">
           <img style="width: 20px;height: 20px;" src="../assets/daohang2.svg" alt="" />
        </div>
        <StoryIdeaDialogMenu v-if="isXsOrDown && isInPagePath" channel="page_menu" />
      </el-row>
      <LoginDialog v-if="showLoginDialogFlag && $i18n.locale === 'zh'"/>
      <LoginDialogEnglish v-if="showLoginDialogFlag && $i18n.locale === 'en'"/>
      <Contact v-if="$i18n.locale === 'zh'" />
      <MessageNotify v-if="showNotifyFlag"/>
      <!-- <StoryRecommendTemplate v-if="showDialogRecommendFlag"/> -->
  </div>

</template>
<script>
import lottie from 'lottie-web'
import StoryIdeaDialogMenu from '@/components/StoryIdeaDialog/index_menu'
import StoryRecommendTemplate from '@/components/StoryIdeaDialog/recommend_template'
import * as AccountApi from '@/api/account'
import * as LoginApi from '@/api/auth'
import * as ImMessageApi from '@/api/immessage'
import * as SkuApi from '@/api/sku'
import * as OrderApi from '@/api/order'
import QRCode from 'qrcode'
import LoginDialog from '@/components/LoginDialog'
import GiveGiftCountDown from '@/components/GiveGiftCountDown'
import LoginDialogEnglish from '@/components/LoginDialog/english'
import { mapState, mapMutations} from 'vuex'
import { trim } from 'xe-utils/methods'
import Contact from '@/components/Contact'
import MessageNotify from '@/components/MessageNotify'
import * as ArticleApi from '@/api/article'
/**
 * 操作系统检测工具
 */
const OSHelper = {
  // 检测操作系统
  detectOS() {
    const userAgent = navigator.userAgent;
     // 检查是否是Apple Silicon (ARM架构)
      // Apple Silicon Mac的userAgent通常包含"Macintosh"和"arm64"
      const isAppleSilicon = userAgent.includes('Macintosh') &&
                            (userAgent.includes('arm64') ||
                             userAgent.includes('Apple Silicon'));

      // 检查是否是Intel Mac
      const isIntelMac = userAgent.includes('Intel');

      if (userAgent.includes('Mac')) {
        if (isAppleSilicon) {
          return 'macosArm64';
        }else if (isIntelMac) {
          return 'macosIntel';
        }else{
          return 'macosIntel'; // 默认认为是 Intel
        }
      } else if (userAgent.includes('Win')) {
        return 'windows';
      } else if (userAgent.includes('Linux')) {
        return 'linux';
      } else {
        return 'unknown';
      }
  },
  // 获取下载链接
  getDownloadLinks() {
    let env = process.env.VUE_APP_CURRENTMODE
    console.log('env', env);
    // return
    if(env == 'production'){
      return {
        macosIntel: 'https://maliwriter.com/static/download/desktop-app/Maliwriter-1.0.0.dmg',
        macosArm64: 'https://maliwriter.com/static/download/desktop-app/Maliwriter-1.0.0-arm64.dmg',
        windows: 'https://maliwriter.com/static/download/desktop-app/Maliwriter-1.0.0.exe',
        linux: 'maliwriter.com',
        default: 'maliwriter.com'
      };
    }else{
      return {
        macosIntel: 'https://maliwriter.com/static/download/desktop-app-test/Maliwriter-1.0.0.dmg',
        macosArm64: 'https://maliwriter.com/static/download/desktop-app-test/Maliwriter-1.0.0-arm64.dmg',
        windows: 'https://maliwriter.com/static/download/desktop-app-test/Maliwriter-1.0.0.exe',
        linux: 'maliwriter.com',
        default: 'maliwriter.com'
      };
    }
  },

  // 根据系统获取对应下载链接
  getDownloadUrl(osType = null) {
    const os = osType || this.detectOS();
    const links = this.getDownloadLinks();
    console.log('links', links);
    return links[os] || links.default;
  },

  // 下载文件
  downloadFile(url, filename = null) {
    const link = document.createElement('a');
    link.href = url;

    if (filename) {
      link.download = filename;
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  // 主下载方法
  downloadApp() {
    const os = this.detectOS();
    const downloadUrl = this.getDownloadUrl(os);

    console.log(`检测到系统: ${os}, 开始下载: ${downloadUrl}`);
    // return ;
    this.downloadFile(downloadUrl);

    return os;
  }
};
export default {
  name: 'HeadNavWriter',
  components: {
    StoryIdeaDialogMenu,LoginDialog,LoginDialogEnglish,Contact,MessageNotify,GiveGiftCountDown,StoryRecommendTemplate
  },
  data() {
    return {
      form: {
        xiboPhone: '',
        phone: '',
        verifyCode: '',
        imageVerifycode: '',
        countryCode: '+86'
      },
      rules: {
        xiboPhone: [
          {validator: this.customValidateUsername, trigger: ['change']}
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: ['blur','change'] },
          { min: 6, max: 6, message: '验证码长度必须为6位', trigger: ['blur','change'] }
        ]
      },
      imageVerifycodeData: '',
      isFormValid: true,
      rereshImageVerifycode: false,
      isGetCodeLoading: false,
      getCaptchaDisabled: false,
      timeLeft: 60, // 初始倒计时时间
      intervalId: null, // 用于存储定时器的 ID
      animTimer: null,
      unreadCount: 0,
      showNotifyFlag:false,
      isXsOrDown: false,
      inPagePath:['/bookbreakdown/index', '/workspace/mywork', '/home', '/', ''],
      merchantOpenFlag: true,
      intervalId: null,
      anim: null,
      animGive: null,
      animFree: null,
      animFree1: null,
      item: {articleGenType: '', articleGenTypeLabel: '', updateTime: ''},
      energyCards: [],
      energyCard: {},
      energyPaySuccess: {},
      imgUrl: '',
      energyActivedIndex: 0,
      energyActivedIndex1: -1,
      showInviteFlag: false,
      showCuxiaoFlag: false,
      isMobileFlag: false,
      boxLeftFlag: false,
      payTime: null,
      inviteBtnText: '复制邀请链接',
      rechargeHeigh: '0',
      realOffsetWidth: 0,
      realScrollWidth: 0,
      showSettingFlag: false,
      showNewGiftV2: true,
      timer: null,
      hour: 24,
      minute: 53,
      second: 53,
      initityTime: '00:00:00',
      giveSuccessFlag: false,
      items: [
        {
          tag: '邀请',
          tag1: '1位',
          color: '#0052D9',
          type: 'circle',
          content: '你可得5万能量，新用户可得10万能量',
          footer: '如果你是首次邀请，你可获得10万能量'
        },
        {
          tag: '邀请',
          tag1: '3位',
          color: '#CED0DA',
          type: 'circle',
          content: '累计获得15万能量',
          footer: '额外获得10万能量'
        },
        {
          tag: '邀请',
          tag1: '6位',
          type: 'circle',
          color: '#CED0DA',
          content: '累计获得30万能量',
          footer: '额外获得20万能量'
        }
      ]
    }
  },
  mounted() {
    this.$eventHub.$on('refreshUnreadCount', (count) => {
      this.unreadCount = count
    })
    window.addEventListener('resize', this.checkWindowSize);
    window.addEventListener('popstate', () => {
      console.log('URI 变化了，当前路径是：', window.location.pathname);
    });
    this.checkWindowSize()

    console.log('detectEnvironment', this.$detectEnvironment());

    // this.currentPagePath = this.$router.history.current.path;
    if(this.isMobile()){
      this.isMobileFlag = true
    }
    this.syncUser();
    this.handlePageSku();
    this.handleNewerGift();
    setTimeout(()=>{
      this.showNotifyFlag = true
    }, 1000)
    this.$nextTick(() => {
      this.anim = lottie.loadAnimation({
        container: this.$refs.lottieContainer, // 动画容器
        renderer: 'svg', // 渲染方式：'svg'/'canvas'/'html'
        loop: false, // 是否循环
        autoplay: true, // 是否自动播放
        // path: '@/assets/icon-home.png.json' // JSON 文件路径
        // 或者使用 animationData 代替 path:
        animationData: require('@/assets/alarm.json')
      })
      if(this.animTimer){
        clearInterval(this.animTimer)
      }
      this.animTimer = setInterval(() => {
        const box = document.querySelector('.ly-reddot-give');
        // console.log('box', box);
        if(box){
          box.classList?box.classList.remove('shake'):''; // 重置
          void box.offsetWidth; // 强制重绘，保证能重新触发动画
          box.classList?box.classList.add('shake'):'';
        }
      }, 5000);
      this.freeGiftPlay1()
    })
    this.startClock()
  },
  computed: {
    ...mapState(['story', 'user', 'token','showMenuFlag','showLoginDialogFlag',
    'dialogShowCostomContactFlag','showDialogRecommendFlag',
    'dialogShowRechargeFlag','showDialogCdpFlag', 'showDialogDpFlag', 'showGenbyoutlineFlag',
    'dialogShowPaySuccessFlag',
    'dialogShowNewerGiftXiboFlag',
    'dialogShowNewerGiftFlag']),
    boxLeft(){
      return this.realScrollWidth - this.realOffsetWidth
    },
    boxRight(){
      return this.realOffsetWidth
    },
    innerWidth() {
      return window.innerWidth
    },
    isInPagePath() {
      console.log('mounted，新的路径是：', this.$router.history.current.path);
      return this.inPagePath.indexOf(this.$router.history.current.path) >= 0
    }
  },
  async created() {
    this.fetchUnreadCount()
  },
  beforeDestroy() {
    // 组件销毁时销毁动画
    this.anim.destroy()
    this.animGive?this.animGive.destroy():''
    this.animFree?this.animFree.destroy():''
    this.animFree1?this.animFree1.destroy():''
    window.removeEventListener('resize', this.checkWindowSize);
    window.addEventListener('popstate', () => {
      console.log('URI 变化了，当前路径是：', window.location.pathname);
    });
    if (this.anim) {
      this.anim.destroy()
    }
  },
  methods: {
    ...mapMutations(['setUser', 'setDialogShowRechargeFlag','setShowLoginDialogFlag',
    'setActiveMenuItem', 'clearCurrentState',
    'setDialogShowCostomContactFlag','setShowMenuFlag',
    'setDialogShowPaySuccessFlag',
    'setDialogShowNewerGiftXiboFlag',
    'setDialogShowNewerGiftFlag','setStory','setShowDialogRecommendFlag',
      'setShowGenbyoutlineFlag', 'setShowDialogCdpFlag', 'setShowDialogDpFlag',
      'setShowChangpianDialogFlag', 'setActiveTemplate', 'setStoryTiaojian']),
    goContactEmail() {
      this.$router.push('/contact-email')
    },
    itemClick(item){
      this.setStory(item)
      setTimeout(()=>{
        if(!item.stepNumber || item.stepNumber == 0 || item.stepNumber == 1){
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
              this.$router.push('/workspace/gen')
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea')
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline')
          }
        }else {
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
            this.$router.push('/workspace/gen' + (item.stepNumber-1))
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea' + item.stepNumber)
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline' + item.stepNumber)
          }
        }
      }, 300)
    },
    getTailByGenType(item){
      let tail = ''
      if(!item.articleGenType){
        return tail;
      }
      if(item.articleGenType == 'GEN_BY_ZHIHU' || item.articleGenType == 'GEN_BY_OUTLINE'){
        tail = this.$i18n.locale === 'zh' ? '短篇小说' : 'Short Story'
      }else if(item.articleGenType == 'GEN_BY_IDEA'){
        tail = this.$i18n.locale === 'zh' ? '超短篇小说' : 'Mini Story'
      }else if(item.articleGenType == 'GEN_BY_CHANGPIAN'){
        tail = this.$i18n.locale === 'zh' ? '长篇小说' : 'Novel'
      }else{
        tail = ''
      }
      return tail;
    },
    changeLanguage() {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$eventHub.$emit('changeLanguage', this.$i18n.locale)
      localStorage.setItem('locale', this.$i18n.locale)
    },
    async fetchUnreadCount(){
      if(this.user && this.user.id){
        const {data} = await ImMessageApi.getStat([this.user.id])
        this.unreadCount = data.data.unread || 0
      }else{
        this.unreadCount =  0
      }

    },
    followerNumber(index) {
      if(index == 0){
        return this.user.followerNumber>0?'':''
      }
      if(index == 1){
        return this.user.followerNumber>2?'':''
      }
      if(index == 2){
        return this.user.followerNumber>5?'':''
      }
    },
    followerNumberTitle(index) {
      if(index == 0){
        return this.user.followerNumber>0?true:false
      }
      if(index == 1){
        return this.user.followerNumber>2?true:false
      }
      if(index == 2){
        return this.user.followerNumber>5?true:false
      }
    },
    replaceWan(index) {
      let text = ''
      let tag = ''
      if(index == 0){
        tag = '5万'
        text = this.items[index].content.replace(tag, '<span style="color: #00B186;font-weight: 600;">'+tag+'</span>')
        tag = '10万'
        text = text.replace(tag, '<span style="color: #00B186;font-weight: 600;">'+tag+'</span>')
      }else if(index == 1){
        tag = '15万'
        text = this.items[index].content.replace(tag, '<span style="color: #00B186;font-weight: 600;">'+tag+'</span>')
      }else if(index == 2){
        tag = '30万'
        text = this.items[index].content.replace(tag, '<span style="color: #00B186;font-weight: 600;">'+tag+'</span>')
      }
      return text
    },
    replaceWanFooter(index) {
      let text = ''
      let tag = ''
      if(index == 0 || index == 1){
        tag = '10万'
        text = this.items[index].footer.replace(tag, '<span style="color: ##057B5F;font-weight: 600;font-size: 16px;">'+tag+'</span>')
      }else if(index == 2){
        tag = '20万'
        text = this.items[index].footer.replace(tag, '<span style="color: ##057B5F;font-weight: 600;font-size: 16px;">'+tag+'</span>')
      }
      return text
    },
    guanbiCuxiao(){
      this.showCuxiaoFlag=false;
      this.$emit('get-hide-flag',false);
    },
    goHome(){
      this.setActiveMenuItem('1')
      if(this.token == ''){
        this.$router.push('/')
      }else{
        this.$router.push('/home')
      }
    },
    tongzhi(){
      console.log('tongzhi')
      this.setActiveMenuItem('3')
      this.$router.push('/notify/index')
    },
    checkWindowSize() {
      // console.log('innerWidth', window.innerWidth);
      if (window.innerWidth < 768) {
        this.isXsOrDown = true;
      }else{
        this.isXsOrDown = false;
      }
    },
    async copyInviteText() {
      let text = document.getElementById('inviteText').innerHTML
      console.log('invite text', text);
      const textArea = document.createElement('textarea');
      textArea.value = text.trim();
      textArea.style.position = 'fixed';  // 防止出现滚动条
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.inviteBtnText = '复制成功'
          console.log('成功复制到剪贴板');
        } else {
          console.error('复制失败');
        }
      } catch (err) {
        console.error('复制时出错: ', err);
      }
      document.body.removeChild(textArea);
    },
    closeXibo(){
      this.setDialogShowNewerGiftFlag(false);
      this.setDialogShowNewerGiftXiboFlag(false);
    },
    abTest(){
      if(this.$i18n.locale === 'zh'){
        // AB测试，单号显示 推荐故事模版弹窗
        if(this.$isLastDigitOdd(this.user.id)){
        // if(true){
          let showInviteFlagAb = localStorage.getItem('showInviteFlagAb')
          if(showInviteFlagAb){

          }else{// AB 弹窗
            this.showInviteFlagAb = true;
            localStorage.setItem('showInviteFlagAb', true)
            this.handleGen('genbyzhihuTempalte')
          }

        }else{
          this.onInvite()
        }
      }
    },
    close(fromFlag){
      console.log('close $isLastDigitOdd', this.$isLastDigitOdd(this.user.id));
      this.energyActivedIndex = 0
      this.giveSuccessFlag = false
      if(this.animGive){
        this.animGive.destroy()
      }
      if(this.animFree){
        this.animFree.destroy()
      }
      this.energyActive(0);
      this.setDialogShowCostomContactFlag(false);
      this.setDialogShowRechargeFlag(false);
      // 新人大礼包
      if(this.dialogShowNewerGiftFlag){
        this.setDialogShowNewerGiftFlag(false);
        this.abTest()
      }
      if(this.dialogShowNewerGiftXiboFlag){
        this.setDialogShowNewerGiftXiboFlag(false);
        this.abTest()
      }

      this.setDialogShowPaySuccessFlag(false);
      if (this.intervalId) {
        // 清除定时器，停止周期性执行
        clearInterval(this.intervalId);
      }
      this.syncUser()
      this.inviteBtnText = '复制邀请链接'
      if(fromFlag && fromFlag == 'pay-success'){
        window.location.reload();
      }
    },
    lingqu(){
      this.close()
      this.showInviteFlag=true;
    },
    getInviteText(){
        return '写作苦手？码哩写作AI让你轻松变身爆款作家！一天轻松搞定10篇短篇，长篇日更只需3分钟！限时免费送10W能量，快来领取你的创作金手指👉'+process.env.VUE_APP_INVITE_URL+'?invite='+this.user.id
    },
    trueOrfalse(drop){
        console.log(1, drop)
    },
    //让下拉菜单显示的方法
    showDrop(){
        this.$refs.dropShow.show()
    },
    //让下拉菜单隐藏的方法
    hideDrop(){
        this.$refs.dropShow.hide()
    },
    recharge4noEnergy(){
      this.close();
      this.$nextTick(()=>{
        this.setDialogShowRechargeFlag(true);
        this.getScrollInfo()
      })
    },
    energyActive(index){
      this.energyActivedIndex1 = -1
      this.energyActivedIndex = index
      this.energyCard = this.energyCards.filter(i => i.id < 100)[index]
      this.generateQRCode();
    },
    energyActive1(index){
      this.energyActivedIndex = -1
      this.energyActivedIndex1 = index
      this.energyCard = this.energyCards.filter(i => i.id > 99)[index]
      this.generateQRCode();
    },
    getScrollInfo(){
      this.$nextTick(()=>{
        const scrollContainer = this.$refs.scrollContainer;
        // console.log(`scrollContainer: `, scrollContainer);
        const offsetWidth = scrollContainer.offsetWidth; // 可视宽度
        const scrollWidth = scrollContainer.scrollWidth; // 实际宽度
        this.realScrollWidth = scrollWidth
        this.realOffsetWidth = offsetWidth
        // console.log(`scrollContainer: `, scrollWidth, offsetWidth);
      })
    },
    scrollLeft() {
       this.$refs.scrollContainer.scrollTo({
         left: 0,
         behavior: 'smooth' // 启用平滑滚动动画
       });
       this.boxLeftFlag = false
    },
    scrollRight() {
        const scrollWidth = this.$refs.scrollContainer.scrollWidth;
        const viewWidth = this.$refs.scrollContainer.clientWidth;
        this.$refs.scrollContainer.scrollTo({
          left: scrollWidth - viewWidth,
          behavior: 'smooth' // 启用平滑滚动动画
        });
        this.boxLeftFlag = true
    },
    getRechargeUrl(){
       return process.env.VUE_APP_BASE_API_URL + 'auth-service/payments/wx/redirect?productId='+ this.energyCard.id +'&Authorization=' + localStorage.getItem('lyToken')
    },
    goRecharge(){
      window.location.href = this.getRechargeUrl()
    },
    onInvite(){
      console.log('onInvite');
      if(this.token == ''){
        this.setShowLoginDialogFlag(true)
      }else{
        this.showInviteFlag = true;
        localStorage.setItem('showInviteFlag', true)
        this.syncUser()
        this.getLastUncompelete()
      }
      this.freeGiftPlay()
    },
    onDownload(){
      console.log('onDownload');
      // 识别不同的操作系统
      OSHelper.downloadApp();
    },
    generateQRCode() {
      let url = this.getRechargeUrl()
      console.log(url)
      SkuApi.page({size:1,shortcutUrl:url}).then(res => {
        // console.log('设置短连接')
        // With promises
        // 二维码的选项
        let options = {
            errorCorrectionLevel: 'H', // 设置错误矫正级别
            margin: 4,                // 设置边距
            width: 256,               // 设置二维码的宽度
            height: 256               // 设置二维码的高度
        };
        QRCode.toDataURL(process.env.VUE_APP_BASE_API_URL + 'auth-service/payments/wx/shortcut?accountId='+ this.user.id)
          .then(url1 => {
            // console.log(url)
            this.imgUrl = url1
          })
          .catch(err => {
            console.error(err)
          })
      })
      SkuApi.page({size:1,shortcutUrl: "writer-recharge-merchant-open-flag-" + this.merchantOpenFlag})
    },
    isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    syncUser(){
      if(!trim(this.token)){
        return false
      }
      const inovkeSetUser = () => {
        console.log('inovkeSetUser', this.user.id);
        if (this.user.id) {
          AccountApi.view(this.user.id).then(res => {
            let result = res.data.data
            result.token = this.token
            this.setUser(result)
          })
        } else {
          setTimeout(()=>{
            inovkeSetUser()
          }, 1000)
        }
      }
      inovkeSetUser()
    },
    lijichuangzuo(){
      console.log('lijichuangzuo');
      this.close()
    },
    handleNewerGift(){
      console.log('coFlag', this.user.coFlag, this.user.xiboFlag);
      // this.setDialogShowNewerGiftFlag(true); return;
      // this.setDialogShowNewerGiftXiboFlag(true); return;
      if(!this.user.id){
        return false;
      }
      if(!trim(this.token)){
        return false
      }
      if(this.user.coFlag){
        let showInviteFlag = localStorage.getItem('showInviteFlag')
        if(showInviteFlag){

        }else{// 邀请弹窗
          this.showInviteFlag = true
          localStorage.setItem('showInviteFlag', true)
        }
        return false;
      }
      // 没有领取新人礼包
      // 判断是否喜播用户，并且绑定了喜播手机号
      if(this.user.xiboFlag && !trim(this.user.xiboPhone)){
        this.setDialogShowNewerGiftXiboFlag(true)
        return false;
      }
      AccountApi.newerGift().then(res => {
        let result = res.data.data;
        if(res.data.code == 0 && result){
          if(this.user.xiboFlag && trim(this.user.xiboPhone)){
            this.setDialogShowNewerGiftXiboFlag(true)
          }else{
            this.setDialogShowNewerGiftFlag(true)
          }
        }else{
          this.setDialogShowNewerGiftFlag(false)
          this.setDialogShowNewerGiftXiboFlag(false)
        }
      })
    },
    handleNewerGiftXibo(bindPhoneFlag){
      console.log('coFlag', this.user.coFlag);
      if(!this.user.id){
        return false;
      }
      if(!trim(this.token)){
        return false
      }
      AccountApi.newerGift().then(res => {
        let result = res.data.data;
        if(res.data.code == 0 && result){
          if(bindPhoneFlag){
            this.setDialogShowNewerGiftXiboFlag(true)
          }else{
            this.setDialogShowNewerGiftFlag(true)
          }
        }else{
          this.setDialogShowNewerGiftFlag(false)
          this.setDialogShowNewerGiftXiboFlag(false)
        }
      })
    },
    handleUpdateSetting(){
      console.log('desktopFlag', this.user.desktopFlag);
      // this.setDialogShowNewerGiftFlag(true)
      AccountApi.update({id: this.user.id, desktopFlag: this.user.desktopFlag}).then(res => {
        this.syncUser()
        this.showSettingFlag = false
      })
    },
    handlePageSku() {
      SkuApi.page({skuType: 'ENERGY_CARD', publishFlag: true}).then(res => {
        let result = res.data.data;
        this.energyCards = result.records
        this.energyCard = this.energyCards[this.energyActivedIndex]

        this.generateQRCode();
      })
    },
    shuangdanPage(){
      let url = "https://www.maliwriter.com/newsdetail/1972556863593807873"
      window.open(url, '_blank');
    },
    handleCommand(cmditem) {
      this.$refs.dropShow.hide()
      if (!cmditem) {
        this.$message('菜单选项缺少command属性')
        return false
      }
      switch (cmditem) {
        case 'setting':
          // 设置
          this.showSettingFlag = true;
          break
        case 'recharge':
          // 充值
          this.handlePageSku();
          this.setDialogShowRechargeFlag(true)
          this.$nextTick(()=>{
            this.getScrollInfo()
          })
          // 启动周期性任务
          this.payTime = this.$time.parseTime(new Date().getTime())
          this.intervalId = setInterval(this.periodicTask, 2000); // 每1000毫秒（1秒）检查一次任务

          break
        case 'orderlist':
          // 订单列表
          this.$router.push('/account/orders')
          break
        case 'energylist':
          // 能量列表
          this.$router.push('/account/energies')
          break
        case 'submission':
          // 我的投稿
          this.$router.push('/account/submissions')
          break
        case 'logout':
          // 清除
          this.clearCurrentState(null)
          // 返回登录页面
          this.$router.push('/')
          break
      }
    },
    // 定义需要周期执行的函数
    async periodicTask() {
      // console.log('执行任务...');

      // 这里放置你的任务逻辑
      // 假设任务成功执行的条件是返回 true
      const taskSuccess = await this.doTask(); // 假设 doTask 是实际执行任务的函数
      // console.log('taskSuccess...', taskSuccess);
      // 如果任务成功执行
      if (taskSuccess && this.intervalId) {
        // 弹窗
        this.close()
        this.$nextTick(()=>{
          this.setDialogShowPaySuccessFlag(true)
          // 刷新当前页面

        })

        // 清除定时器，停止周期性执行
        clearInterval(this.intervalId);
      }
    },
    // 假设这是实际执行任务的函数，返回布尔值表示任务是否成功
    async doTask() {
      // 任务逻辑...
      // 假设任务执行成功
      // console.log('doTask user', this.user);
      if(!this.user || !this.user.id){
        return false;
      }

      // console.log("payTime: " , this.payTime);
      let res = await OrderApi.page({accountId: this.user.id, payTime: this.payTime});
      if(res.data.code == 0 && Number(res.data.data.total) > 0){
         this.energyPaySuccess = res.data.data.records[0]
         return true;
      }else{
        return false;
      }
    },
    handlebindPhone(bindPhoneFlag){// 放弃和领取
      AccountApi.update({id: this.user.id, verifyCode: this.form.verifyCode, countryCode: this.form.countryCode, xiboFlag: bindPhoneFlag, xiboPhone: (bindPhoneFlag?this.form.xiboPhone:''), fromType: 'writer-client-xibo-phone'}).then(res => {
        // 更新完手机号，弹窗
        if(res.data.code != 0){
          return false;
        }
        let result = res.data.data;
        this.setUser(result)
        setTimeout(()=>{
          this.handleNewerGiftXibo(bindPhoneFlag)
        }, 300);
      })
    },
    customValidateUsername(rule, value, callback) {
      // 根据表单数据执行不同的验证

      if (this.form.xiboPhone.length <= 0) {
        this.showImageVerifycode = false
        callback(new Error('请输入手机号！'));
      } else if (this.form.countryCode.startsWith('+86')) {
        const regex = /^1[3-9]\d{9}$/;
        if(!regex.test(value)){
          this.showImageVerifycode = false
          callback(new Error('手机号格式有误！'));
        } else {
          setTimeout(()=>{
            this.getImageVerifycode()
          }, 300);
          callback();
        }
      } else {
        setTimeout(()=>{
          this.getImageVerifycode()
        }, 300);
        callback();
      }
    },
    getImageVerifycode(){
      console.log('getImageVerifycode', this.rereshImageVerifycode);
      if(this.rereshImageVerifycode==true){

        return false;
      }
      this.showImageVerifycode = true
      this.form.phone = this.form.xiboPhone
      let param = Object.assign({}, this.form)
      param.countryCode = param.countryCode.trim()
      LoginApi.getImageVerifycode(param)
        .then(res => {
          // 获取成功
          if (res.data.code === 0) {
            this.imageVerifycodeData = res.data.data.imageVerifycode
            this.form.imageVerifycode = ''
          }
        })
    },
    getLastUncompelete(){
      // 获取表格数据
      let params = {
        size: 1,
        accountId: this.user.id,
        articleGroup: 'STORY',
        articleState: 'SUBMITTED',
        fromType: 'writer-web'
      }
      ArticleApi.page(params).then(res => {
        let result = res.data.data.records;
        if(result.length>0){
          this.item = result[0]
        }

      })
    },
    startCountdown() {
      // console.log('this.form', this.form); return false;
      this.isGetCodeLoading = true
      this.isFormValid = true;
      if (this.intervalId) {
        clearInterval(this.intervalId); // 如果已经有一个定时器在运行，先清除
      }
      this.$refs.formRef.clearValidate('countryCode');
      this.$refs.formRef.validateField('countryCode', (message) => {
        console.log('countryCode', message);
        if (message) {
          this.isFormValid = false;
          this.isGetCodeLoading = false
        }
      });

      this.rereshImageVerifycode=true
      this.$refs.formRef.clearValidate('xiboPhone');
      this.$refs.formRef.validateField('xiboPhone', (message) => {
        if (message) {
          this.isFormValid = false;
          this.isGetCodeLoading = false
        }
      });

      setTimeout(()=>{
        this.rereshImageVerifycode=false
        if (this.isFormValid) {
          let param = Object.assign({}, this.form)
          param.phone = this.form.xiboPhone
          if(param.imageVerifycode){
            param.imageVerifycode = param.imageVerifycode.toLowerCase()
          }

          param.countryCode = param.countryCode.trim()
          LoginApi.getVerifycode(param)
            .then(res => {
              // 获取成功
              if (res.data.code === 0) {
                this.getCaptchaDisabled = true;
                this.isGetCodeLoading = false
                this.intervalId = setInterval(() => {
                  if (this.timeLeft > 0) {
                    this.timeLeft--; // 每秒减少 1
                  } else {
                    clearInterval(this.intervalId); // 倒计时结束，清除定时器
                    this.timeLeft = 60; // 重置倒计时时间
                    this.getCaptchaDisabled = false;
                  }
                }, 1000);

                this.$nextTick(() => {
                  this.$refs.verificationCodeInput.focus();
                });
              }else{
                this.getCaptchaDisabled = false;
                this.isGetCodeLoading = false
              }
            })
        } else {
          console.log('手机号码验证失败');
          this.getCaptchaDisabled = false;
          this.isGetCodeLoading = false
          return false
        }
      }, 1000);
    },
    downloadGift(){
      console.log('downloadFlag', this.user.downloadFlag);
      if(!this.user.id){
        return false;
      }
      if(!trim(this.token)){
        return false
      }
      if(this.user.downloadFlag){
        this.$message.warning('已经领取过！')
        return false;
      }
      AccountApi.downloadGift().then(res => {
        this.syncUser()
        this.$message.success('领取成功')
      })
    },
    giveGift(){
      console.log('giveFlag', this.user.giveFlag);
      if(!this.user.id){
        return false;
      }
      if(!trim(this.token)){
        return false
      }
      if(this.user.giveFlag){
        return false;
      }
      AccountApi.giveGift().then(res => {
        this.syncUser()
        let checkSuccess = setInterval(()=>{
          if(!this.user.giveFlag){

          }else{
            clearInterval(checkSuccess)
            this.giveGiftSuccess();
          }
        }, 500)
      })
    },
    freeGift(){
      console.log('freeFlag', this.user.freeFlag);
      if(!this.user.id){
        return false;
      }
      if(!trim(this.token)){
        return false
      }
      if(this.user.freeFlag){
        return false;
      }
      AccountApi.freeGift().then(res => {
        this.syncUser()
        let checkSuccess = setInterval(()=>{
          if(!this.user.giveFlag){

          }else{
            clearInterval(checkSuccess)
            this.freeGiftPlay1()
          }
        }, 500)
      })
    },
    giveGiftSuccess(){
      this.giveSuccessFlag = true;
      this.$nextTick(() => {
        this.animGive = lottie.loadAnimation({
          container: this.$refs.giveSuccessContainer, // 动画容器
          renderer: 'svg', // 渲染方式：'svg'/'canvas'/'html'
          loop: false, // 是否循环
          autoplay: true, // 是否自动播放
          animationData: require('@/assets/submission-success.json')
        })
      })
    },
    freeGiftPlay(){
      if(this.animFree){
        this.animFree.destroy()
      }
      this.$nextTick(() => {
        this.animFree = lottie.loadAnimation({
          container: this.$refs.freeContainer, // 动画容器
          renderer: 'svg', // 渲染方式：'svg'/'canvas'/'html'
          loop: true, // 是否循环
          autoplay: true, // 是否自动播放
          animationData: require('@/assets/infinity.json')
        })
      })
    },
    freeGiftPlay1(){
      if(this.animFree1){
        this.animFree1.destroy()
      }
      this.$nextTick(() => {
        this.animFree1 = lottie.loadAnimation({
          container: this.$refs.freeContainer1, // 动画容器
          renderer: 'svg', // 渲染方式：'svg'/'canvas'/'html'
          loop: true, // 是否循环
          autoplay: true, // 是否自动播放
          animationData: require('@/assets/infinity.json')
        })
      })
    },
    startClock() {
        if(this.timer){
          clearInterval(this.timer)
        }
        this.updateTime(); // 立即显示一次
        this.timer = setInterval(this.updateTime, 1000);
    },
    updateTime() {
        const now = new Date();
        // 获取小时、分钟、秒
        let hours = (23 - now.getHours()).toString().padStart(2, '0');
        const minutes = (59 - now.getMinutes()).toString().padStart(2, '0');
        const seconds = (59 - now.getSeconds()).toString().padStart(2, '0');

        // 更新显示
        this.hour = hours;
        this.minute = minutes;
        this.second = seconds;
        this.initityTime = hours + ":" + minutes +  ":" + seconds
    },
    isNextDayEqualToToday() {
      // 将 createTime 和 today 转换为 Date 对象
      const createDate = new Date(this.user.createTime.split(' ')[0]);
      const todayDate = new Date();

      // 获取 createTime 的第二天
      createDate.setDate(createDate.getDate() + 1);

      // 比较年、月、日是否相等
      return (
        createDate.getFullYear() === todayDate.getFullYear() &&
        createDate.getMonth() === todayDate.getMonth() &&
        createDate.getDate() === todayDate.getDate()
      );
    },
    isFreeNewer() {
      // 将 createTime 和 today 转换为 Date 对象
      const createDate = new Date(this.user.createTime.split(' ')[0]);
      const todayDate = new Date();

      // 比较年、月、日是否相等
      return (
        createDate.getFullYear() === todayDate.getFullYear() &&
        createDate.getMonth() === todayDate.getMonth() &&
        createDate.getDate() === todayDate.getDate()
      );
    },
    handleGen(cmditem) {
      if (!cmditem) {
        this.$message.error(this.$t('menu_missing_command'))
        return
      }
      this.close()
      const story = { id: '' }
      switch (cmditem) {
        case 'genbyidea': // cdp
          // gen story
          story.articleGenType = 'GEN_BY_IDEA'
          story.articleType = 'TANBI_DOUBLE_BOY'
          this.setStory(story)
          this.setShowDialogCdpFlag(true)
          break
        case 'genbyoutline': // duanpian dingzhi
          // gen story
          story.articleGenType = 'GEN_BY_OUTLINE'
          story.articleType = 'FEEL_GOOD'
          story.articleStyle = 'ZHENGWEN'
          story.writingPerspective = 'FIRST_PERSON'
          this.setStory(story)
          this.setShowGenbyoutlineFlag(true)
          break
        case 'genbyzhihu': // dp
          story.articleGenType = 'GEN_BY_ZHIHU'
          story.articleType = 'FEEL_GOOD'
          this.setStory(story)
          this.$router.push({ path: '/workspace/gen' })
          this.$nextTick(() => {
            setTimeout(() => { this.setShowDialogDpFlag(true) }, 300)
          })
          break
        case 'genbyzhihuTempalte': // dp
          story.articleGenType = 'GEN_BY_ZHIHU'
          story.articleType = 'FEEL_GOOD'
          this.setStory(story)
          this.$router.push({ path: '/workspace/gen' })
          this.$nextTick(() => {
            setTimeout(() => { this.setShowDialogRecommendFlag(true) }, 300)
          })
          break
        case 'genbychangpian': // changpian
          story.articleGenType = 'GEN_BY_CHANGPIAN'
          story.articleType = 'CP_YANQING'
          this.setStory(story)
          this.setShowChangpianDialogFlag(true)
          this.$router.push({ path: '/workspace/gencp' })
          break
        case 'chaishu': // chaishu

          this.$router.push({ path: '/bookbreakdown/index' })
          break
      }
    },
  }
}
</script>
<style>

</style>
<style scoped lang="scss">
.active-title {
  color: #00B186;
}
.inactive-title {
  color: rgba(0,0,0,0.9);
}
div {
  color: #ffffff;
}
.org-logo {
  width: 2rem;
  height: auto;
}
.user-avatar {
  width: 2rem;
  height: auto;
}

span {
  vertical-align: middle;
  padding-left: 0.5rem;
}
.writer-cashier {
  color: #000000;
  div {
    color:  #000000;
  }
  padding: 2rem;
  &-info {
    font-weight: 400;
    font-size: 1rem;

    &-item {
      padding: .6rem 0;
      padding-left: 4.25rem;
    }
  }
}
.writer-cashier-dialog {
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .el-dialog__body {
    padding: 0 !important;
    background-image: url('../assets/pay-success-bg.png');
    background-repeat: no-repeat;
    background-position: right bottom;
  }
}
.recharge-dialog {
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .el-dialog__body {
    padding: 0 !important;
  }
}
/deep/ .el-dropdown-menu__item {
  color: #ffffff !important;
  padding: 0 10px;
  margin: 0 10px;
  line-height: 2rem;
}
/deep/ .el-dropdown-menu__item:hover {
  background-color: rgba(92, 90, 90, .4) !important;
  border-radius: 6px;
  color: #ffffff !important;
}
.custom-dropdown {
  /deep/ .popper__arrow {
    border-bottom-color: #000000 !important;
  }
  /deep/ .popper__arrow::after {
    border-bottom-color: #000000 !important;
  }
}
.newer-gift-dialog {
  /deep/ .el-dialog {
    background: transparent !important;
    border: none;
    box-shadow: 0 0 0 transparent;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: transparent;
      background: transparent;
      border: none;
  }
}
.newer-gift-dialog-v2-en {
  border: none;
  border-radius: 20px;
  .mly-mt {
    margin-top: 280px;
  }
  .mly-p{
    padding: 0 40px;
  }
  .mly-fs-small{
    font-size: 14px;
  }
  .mly-fs-middle{
    font-size: 18px;
  }
  .mly-pc-mt-25{
    margin-top: 2.5rem;
  }
  .mly-pc-mt-2{
    margin-top: 2rem;
  }
  .mly-pc-mt-125{
    margin-top: 1.25rem;
  }
  .mly-pc-mb-1{
    margin-bottom: 1rem;
  }
  /deep/ .el-dialog__header {
    border: none;
    background: transparent;
    width: 479px;
    height: 0;
    padding: 0;
    display: flex;
    justify-content: flex-end;
  }
  /deep/ .el-dialog__body {
    height: 687px;
    width: 479px;
    padding: 20px 0;
    border: none;
    // background-image: url('../assets/newer-gift-en.png')!important;
    background-repeat: no-repeat;
    background-size: auto auto; /* 根据需要调整 */
    background-position: left top;
    border-radius: 20px 20px 20px 20px;
  }
  /deep/ .el-dialog {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    background-color: transparent!important;
    margin: 0 auto;
    width: 479px;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
      display: none;
  }
  /deep/ .el-dialog__headerbtn {
      position: relative !important;
      right: 0;
  }
}
.newer-gift-dialog-v2 {
  border: none;
  border-radius: 20px;
  .mly-mt {
    margin-top: 280px;
  }
  .mly-p{
    padding: 0 40px;
  }
  .mly-fs-small{
    font-size: 14px;
  }
  .mly-fs-middle{
    font-size: 18px;
  }
  .mly-pc-mt-25{
    margin-top: 2.5rem;
  }
  .mly-pc-mt-2{
    margin-top: 2rem;
  }
  .mly-pc-mt-125{
    margin-top: 1.25rem;
  }
  .mly-pc-mb-1{
    margin-bottom: 1rem;
  }
  /deep/ .el-dialog__header {
    border: none;
    background: transparent;
    width: 479px;
    height: 0;
    padding: 0;
    display: flex;
    justify-content: flex-end;
  }
  /deep/ .el-dialog__body {
    height: 687px;
    width: 479px;
    padding: 20px 0;
    border: none;
    background-image: url('../assets/newer-gift-v2.png');
    background-repeat: no-repeat;
    background-size: auto auto; /* 根据需要调整 */
    background-position: left top;
    border-radius: 20px 20px 20px 20px;
  }
  /deep/ .el-dialog {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    background-color: transparent;
    margin: 0 auto;
    width: 479px;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #ffffff;
      background-color: rgba(255, 255, 255, .4);
      border: none;
      border-radius: 100%;
      padding: .2rem;
  }
  /deep/ .el-dialog__headerbtn {
      position: relative !important;
      right: 0;
  }
}

.invite-newer-gift-dialog-v2 {
  border: none;
  border-radius: 20px;
  .mly-mt {
    margin-top: 200px;
  }
  .mly-p{
    padding: 0 40px;
  }
  .mly-fs-small{
    font-size: 14px;
  }
  .mly-fs-middle{
    font-size: 16px;
  }
  .mly-fs-middle-large{
    font-size: 24px;
  }
  .mly-pc-mt-25{
    margin-top: 2.5rem;
  }
  .mly-pc-mt-2{
    margin-top: 2rem;
  }
  .mly-pc-mt-125{
    margin-top: 1.25rem;
  }
  .mly-pc-mb-1{
    margin-bottom: 1rem;
  }
  .story-item {
    border-radius: 20px;
    border: 1px solid #0052D9;
    font-weight: 600;
    color: #0052D9;
    padding: .5rem 0;
    margin: 1rem 0;
    text-align: center;
    cursor: pointer;
  }
  /deep/ .el-dialog__header {
    border: none;
    background: transparent;
    width: 572px;
    height: 0;
    padding: 0;
    display: flex;
    justify-content: flex-end;
  }
  /deep/ .el-dialog__body {
    height: 720px;
    width: 572px;
    padding: 20px 0;
    border: none;
    background-image: url('../assets/invite-bg.png');
    background-repeat: no-repeat;
    background-size: auto auto; /* 根据需要调整 */
    background-position: left top;
    border-radius: 20px 20px 20px 20px;
  }
  /deep/ .el-dialog {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    background-color: transparent;
    margin: 0 auto;
    width: 479px;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #ffffff;
      background-color: rgba(255, 255, 255, .4);
      border: none;
      border-radius: 100%;
      padding: .2rem;
  }
  /deep/ .el-dialog__headerbtn {
      position: relative !important;
      right: 0;
  }
}
.newer-gift-dialog-xibo-v2 {
  /deep/ .el-dialog__body {
    background-image: url('../assets/newer-gift-xibo-v2.png') !important;
  }
}
/* 鼠标悬停时的样式 */
.invite-button:hover {
  opacity: 0.8; /* 按钮本身可以稍微透明一些，以便蒙版更明显 */
}

.invite-button::after {
  /* 蒙版层，绝对定位覆盖在按钮上 */
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: brown; /* 褐色背景 */
  opacity: 0; /* 默认透明度为0，即不显示蒙版 */
  transition: opacity 0.3s; /* 平滑过渡效果 */
}
.recharge-dialog {
  /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #FDFEFE;
      font-weight: bold;
      border: none;
  }
}

.mly-switch {
  /deep/ .el-switch__label.is-active{
    color: rgba(0,0,0,0.5);
    white-space: nowrap;
  }
  /deep/ .el-switch__label {
    white-space: nowrap;
    color: rgba(0,0,0,0.5);
    span {
      font-size: 10px;
    }
  }
  /deep/ .el-switch__core {
    width: 30px !important;
    height: 14px !important;
    border-radius: 10px !important;
  }
  /deep/ .el-switch__core:after {
    top: 0 !important;
    left: 17px !important;
    width: 12px !important;
    height: 12px !important;
  }
  /deep/ .el-switch.is-checked .el-switch__core {
    width: 30px !important;
    height: 14px !important;
    left: 0 !important;
    border-radius: 10px !important;
  }
}
.daechongzhi {
  flex-direction: row;
}

.time-item {
  background: rgba(54,110,244,0.67);
  border-radius: 6px 6px 6px 6px;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  padding: 0.5rem;
  width: 4rem;
}
/* 鼠标悬停时的样式 */
.give-done {
  opacity: 0.5; /* 按钮本身可以稍微透明一些，以便蒙版更明显 */
}
@media (min-width: 768px) {
  .mobile-bg-circle {
    background-color: #ffffff;
    padding-bottom: 30px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}
/* 小屏下的样式 */
@media (max-width: 768px) {

  .daechongzhi {
    flex-direction: column;
  }

  .daechongzhi-right {
    margin-top: 1rem;
    padding-right: 1rem;
  }
  .recharge-pay-right {
    width: 100%;
  }
  .recharge-pay-left{
    width: 100%;
    overflow: scroll hidden;
    padding-right: 1rem;
  }
  .recharge-dialog {
    /deep/ .el-dialog {
      margin-top: 2px !important;
    }
  }
  // newer-gift-v2
  .newer-gift-dialog-v2 {
    border: none;
    border-radius: 20px;
    .mly-mt {
      margin-top: calc( 280 * 80vw / 479 );
    }
    .mly-p{
      padding: 0 calc( 40 * 80vw / 479 );
    }
    .mly-fs-small{
      font-size: 12px;
    }
    .mly-fs-middle{
      font-size: 16px;
    }
    .mly-pc-mt-25{
      margin-top: 0;
    }
    .mly-pc-mt-2{
      margin-top: 0;
    }
    .mly-pc-mt-125{
      margin-top: 0;
    }
    .mly-pc-mb-1{
      margin-bottom: 0;
    }
    .mobile-bg-circle {
      background-color: #ffffff;
      padding-bottom: 30px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    /deep/ .el-dialog__header {
      border: none;
      background: transparent;
      width: 80vw;
      max-width: 479px;
      height: 0;
      padding: 0;
      display: flex;
      justify-content: flex-end;
    }
    /deep/ .el-dialog__body {
      height: auto;
      width: 80vw;
      max-width: 479px;
      padding: 20px 0;
      border: none;
      background-image: url('../assets/newer-gift-v2.png');
      background-repeat: no-repeat;
      background-size: 80vw auto; /* 根据需要调整 */
      background-position: left top;
      border-radius: 20px 20px 20px 20px;
      margin: 0 auto;
    }
    /deep/ .el-dialog {
      border: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      background-color: transparent;
      margin: 0 auto;
      width: 80vw;
      max-width: 479px;
    }
    /deep/ .el-dialog__headerbtn .el-dialog__close {
        color: #ffffff;
        background-color: rgba(255, 255, 255, .4);
        border: none;
        border-radius: 100%;
        padding: .2rem;
    }
    /deep/ .el-dialog__headerbtn {
        position: relative !important;
        right: 0;
    }
  }
  // invite-newer-gift-v2
  .invite-newer-gift-dialog-v2 {
    border: none;
    border-radius: 20px;
    .mly-mt {
      margin-top: calc( 200 * 80vw / 572 );
    }
    .mly-p{
      padding: 0 calc( 40 * 80vw / 572 );
    }
    .mly-fs-small{
      font-size: 12px;
    }
    .mly-fs-middle{
      font-size: 16px;
    }
    .mly-fs-middle-large{
      font-size: 18px;
    }
    .mly-pc-mt-25{
      margin-top: 0;
    }
    .mly-pc-mt-2{
      margin-top: 0;
    }
    .mly-pc-mt-125{
      margin-top: 0;
    }
    .mly-pc-mb-1{
      margin-bottom: 0;
    }
    .mobile-bg-circle {
      background-color: #ffffff;
      padding-bottom: 30px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    /deep/ .el-dialog__header {
      border: none;
      background: transparent;
      width: 80vw;
      max-width: 572px;
      height: 0;
      padding: 0;
      display: flex;
      justify-content: flex-end;
    }
    /deep/ .el-dialog__body {
      height: auto;
      width: 80vw;
      max-width: 572px;
      padding: 20px 0;
      border: none;
      background-image: url('../assets/invite-bg.png');
      background-repeat: no-repeat;
      background-size: 80vw auto; /* 根据需要调整 */
      background-position: left top;
      border-radius: 20px 20px 20px 20px;
      margin: 0 auto;
    }
    /deep/ .el-dialog {
      border: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      background-color: transparent;
      margin: 0 auto;
      width: 80vw;
      max-width: 572px;
    }
    /deep/ .el-dialog__headerbtn .el-dialog__close {
        color: #ffffff;
        background-color: rgba(255, 255, 255, .4);
        border: none;
        border-radius: 100%;
        padding: .2rem;
    }
    /deep/ .el-dialog__headerbtn {
        position: relative !important;
        right: 0;
    }
  }
}

.recharge {
  span {
    padding: 0;
    vertical-align: baseline;
  }
  &-user-bg{
    font-size: 1.2rem;
    background: linear-gradient( 95deg, #075DE9 0%, #3DFFD0 100%);
    border-radius: 20px 20px 0 0;
  }
  &-user-img {
    background-image: url('../assets/recharge-bg.png');
    background-size: 60%; /* 根据需要调整 */
    background-repeat: no-repeat;
    background-position: right bottom;
    padding: 1.5rem 2rem 3.25rem 2rem;
  }
  &-user-info {
    margin-left: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 1rem;
    &-item {
      padding: .25rem 0;
    }
  }
  &-title{
    &-box {
      margin-top: -1.8rem;
      background: #ffffff;
      width: 11rem;
      padding: .4rem 0;
      border-radius: 0px 50px 0 0;
      &-text {
        color: #242424;
        font-size: 1rem;
        margin-left: .5rem;
        margin-right: 1rem;
      }
    }
  }
  &-energy {
    overflow-x: scroll;
    overflow-y: hidden;
    margin: 1rem 2rem;
    &-item {
      cursor: pointer;
      box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.11);
      border-radius: 20px;
      margin-right: 1.5rem;
      margin-bottom: .5rem;
      padding-top: .25rem;
      border: 4px solid transparent;
      &-title {
        background: linear-gradient( 289deg, #FCFDFF 0%, #F2F3FF 100%);
        border-radius: 20px;
        padding: .25rem 1rem;
      }
      &-text {
        font-weight: 600;
        font-size: 18px;
        text-wrap: nowrap;
        white-space: nowrap;
        text-align: center;
        color: #0052D9;
        margin: 6px 0;
      }
      &-active {
        background: #E5E7FC;
        border: 4px solid #0052D9;
      }
      &-active1 {
        border: 4px solid rgb(113, 62, 15);
      }
    }
  }
  &-pay {
    background: linear-gradient( 90deg, #F4F5FF 0%, #E5E7FC 100%);
    border-radius: 20px;
    padding: 1rem;
    margin: 0rem 2rem;
    &-left {

    }
  }
}
.text-gradient {
  /* 定义渐变的起始颜色 */
  background-image: linear-gradient(to right, #07F2C5, #0052D9);

  /* 将背景裁剪到文本区域 */
  background-clip: text;

  /* 使文本颜色透明，这样背景才会透过来 */
  color: transparent;

  /* 确保文本不会被背景覆盖 */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  /* 定义文本的字体大小 */
  // font-size: 2em;
  /* 定义文本的字体 */
  // font-family: Arial, sans-serif;
  text-wrap: nowrap !important;
}
/* 隐藏滚动条 */
.container::-webkit-scrollbar {
    width: 0; /* 垂直滚动条宽度 */
    height: 0; /* 水平滚动条高度 */
}
.writer-cashier-dialog {
  /deep/  .el-dialog {
    max-width: 500px;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #272636;
      font-weight: bold;
      border: none;
  }
}
.slider-arraw {
      border-radius: 50%;
      color: #ffffff;
      font-size: 1rem;
      cursor: pointer;
      padding: .5rem !important;
      background: rgba(0,0,0,0.2);
}
.scroll-transition {
  transition: scrollLeft 1s ease; /* 调整过渡效果和时间 */
  /* 其他样式 */
}
/* 全局滚动条轨道的padding */
.mali-scrollbar::-webkit-scrollbar-track {
  background-color: transparent;
  margin: 0 30px;//滑轨
}

/* 滚动条的样式 */
.mali-scrollbar::-webkit-scrollbar {
  height: 10px;//滑块高度
  background-color: transparent;
}

.mali-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);//滑块颜色
}
.ly-reddot {
	position: absolute;
  right: 12px;
  top: 6px;
	background: #FF2424;
	border-radius: 100px 100px 100px 100px;
  padding: 2px 4px;
  font-weight: 600;
  font-size: 10px;
  color: #FFFFFF;
  z-index: 1;
}
.ly-reddot-give {
	position: absolute;
  right: 12px;
  top: -7px;
	background: #FF2424;
	border-radius: 100px 100px 100px 100px;
  padding: 4px 6px;
  font-weight: 600;
  font-size: 10px;
  color: #FFFFFF;
  z-index: 1;
}
/* 右下角三角箭头（尾巴） */
.badge::after{
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  right: 1px;         /* 调整与右侧距离 */
  bottom: -4px;        /* 让尾巴露出在徽标外 */
  background: #FF2424;
  /* 用 clip-path 画一个直角三角形，直角在左上，指向右下 */
  clip-path: polygon(0 0, 100% 0, 0 100%);
}
.rounded-input {
  /deep/ .el-input__inner {
    border-radius: 10px !important;
  }
}
/deep/ .yanzhengma1.el-button {
  background-color: #ffffff; /* 设置背景颜色 */
  border: 1px solid #DCDCDC;
  box-shadow: none;
  cursor: pointer;
  border-radius: 10px !important;
}

/deep/ .el-input-group__append {
  border: 0 !important;
  background-color: #FFFFFF !important;
}
.shake {
    animation: shake 0.8s ease-in-out 3;

    // animation: shake 1s infinite  steps(1, start);
    // animation-delay: 5s; /* 每次动画后等待4秒 */
    // animation-duration: 5s; /* 动画本身持续1秒 */
}

@keyframes shake {
    0%, 100% { transform: translateX(0) rotate(0); }
    20% { transform: translateX(-6px) rotate(-5deg); }
    40% { transform: translateX(4px) rotate(4deg); }
    60% { transform: translateX(-2px) rotate(-3deg); }
    80% { transform: translateX(0px) rotate(2deg); }
}
.word-count-tail {
  border-radius: 6px 0px 20px 0px;
  width: auto; /* 默认值，但明确设置有助于理解 */
  white-space: nowrap; /* 防止文本换行 */
  display: inline-block;
  padding: .25rem 1.5rem .25rem 1rem;
  // font-weight: 600;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  &-cdp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F2F3FE 100%);
    color: #0052D9;
  }
  &-dp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F6F2FE 100%);
    color: #4043FF;
  }
  &-cp{
    background: linear-gradient( 90deg, #FFE9BC 0%, #FFF7DC 100%);
    color: #FD733B;
  }
}
.writer-story-card {
  cursor: pointer;
  width: 100%;
  box-shadow: none !important;
  max-width: 400px;
  box-sizing: border-box; /* 边框计算在宽度内 */
  border-radius: 16px;
  span {
    padding: 0;
  }
  /deep/ .el-card__body {
    padding: 10px;
  }
  &-title {
    font-weight: 600;
    font-size: 1rem;
    color: rgba(0,0,0,0.9);
    height: 3rem;
    line-height: 1.5rem;
  }
  &-time {
    // font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.3);
    line-height: 22px;
    &-label {
      margin-right: .5rem;
    }
  }
  &-menu {
    &-delete {
      // padding: .5rem;
      img {
        margin-right: .5rem;
      }
      // background: #F2F3FF;
      border-radius: 3px;
      color: #0052D9;
      font-size: .8rem;
    }
  }
}
</style>
